import { render, staticRenderFns } from "./YouTubePlayer.vue?vue&type=template&id=91f33f70&scoped=true"
import script from "./YouTubePlayer.vue?vue&type=script&lang=js"
export * from "./YouTubePlayer.vue?vue&type=script&lang=js"
import style0 from "./YouTubePlayer.vue?vue&type=style&index=0&id=91f33f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f33f70",
  null
  
)

export default component.exports